/**
 * Reducer for timeline, playback and animations
 *
 */

import {
  SELECT_ARTBOARD,
  SET_PREVIEW_CURRENT_TIME,
  SET_PREVIEW_DURATION,
  SET_PREVIEW_STATE,
  SET_TRANSITION_STATE,
  UPDATE_STORY_MUSIC_PLAYBACK,
} from "../_actions/types";
import { transitionMap } from "../TldrPreview/TransitionHelper";

export const initialState = {
  playbackState: "",
  isMusicExpandedView: false,
  selectedArtboard: {
    idx: null,
    id: null,
  },
  previewDuration: 1, // Total duration used in preview
  previewCurrentTime: 0, // Current time used in preview
  previewState: "init", // Current time used in preview
  previewTransitionState: {
    from: null,
    to: null,
    progress: 0,
    transition: transitionMap(null),
  }, // Preview transition state
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_STORY_MUSIC_PLAYBACK:
      return { ...state, playbackState: action.payload };
    case SELECT_ARTBOARD:
      return { ...state, selectedArtboard: { id: action.id, idx: action.idx } };
    case SET_PREVIEW_DURATION:
      return { ...state, previewDuration: action.payload };
    case SET_PREVIEW_CURRENT_TIME:
      return { ...state, previewCurrentTime: action.payload };
    case SET_PREVIEW_STATE:
      return { ...state, previewState: action.payload };
    case SET_TRANSITION_STATE:
      return {
        ...state,
        previewTransitionState: {
          ...state.previewTransitionState,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
